import { useMail } from '../../context/MailContext';
import './Sidebar.css';

const FOLDERS = [
  { id: 'inbox', label: 'Inbox', icon: '📥' },
  { id: 'sent', label: 'Sent', icon: '📤' },
  { id: 'scheduled', label: 'Scheduled', icon: '🕐' },
  { id: 'drafts', label: 'Drafts', icon: '📝' },
  { id: 'starred', label: 'Starred', icon: '⭐' },
  { id: 'trash', label: 'Trash', icon: '🗑' },
];

const SETTINGS = [
  { id: 'autoresponder', label: 'Auto-Responders', icon: '🤖' },
  { id: 'signature', label: 'Signature', icon: '✍' },
  { id: 'settings', label: 'Settings', icon: '⚙' },
];

export default function Sidebar({ onNav }) {
  const { activeFolder, setActiveFolder, unreadCount, openCompose, emails } = useMail();

  const scheduledCount = emails.filter(e => e.folder === 'scheduled').length;
  const draftsCount = emails.filter(e => e.folder === 'drafts').length;
  const storageUsed = 1.7;
  const storageTotal = 5;

  const handleNav = (id) => {
    setActiveFolder(id);
    if (onNav) onNav(id);
  };

  return (
    <aside className="sidebar">
      <button className="compose-btn" onClick={() => openCompose()}>
        <span className="compose-icon">✏</span> Compose
      </button>

      <nav className="sidebar-nav">
        <div className="nav-group">
          {FOLDERS.map(f => (
            <button
              key={f.id}
              className={`nav-item ${activeFolder === f.id ? 'active' : ''}`}
              onClick={() => handleNav(f.id)}
            >
              <span className="nav-icon">{f.icon}</span>
              <span className="nav-label">{f.label}</span>
              {f.id === 'inbox' && unreadCount('inbox') > 0 && (
                <span className="nav-badge primary">{unreadCount('inbox')}</span>
              )}
              {f.id === 'scheduled' && scheduledCount > 0 && (
                <span className="nav-badge muted">{scheduledCount}</span>
              )}
              {f.id === 'drafts' && draftsCount > 0 && (
                <span className="nav-badge muted">{draftsCount}</span>
              )}
            </button>
          ))}
        </div>

        <div className="nav-section-label">Manage</div>
        <div className="nav-group">
          {SETTINGS.map(s => (
            <button
              key={s.id}
              className={`nav-item ${activeFolder === s.id ? 'active' : ''}`}
              onClick={() => handleNav(s.id)}
            >
              <span className="nav-icon">{s.icon}</span>
              <span className="nav-label">{s.label}</span>
            </button>
          ))}
        </div>
      </nav>

      <div className="sidebar-footer">
        <div className="storage-info">
          <div className="storage-row">
            <span className="storage-label">Storage</span>
            <span className="storage-val">{storageUsed} / {storageTotal} GB</span>
          </div>
          <div className="storage-track">
            <div
              className="storage-fill"
              style={{ width: `${(storageUsed / storageTotal) * 100}%` }}
            ></div>
          </div>
        </div>
      </div>
    </aside>
  );
}
